import React, { useState, useEffect, useCallback } from "react";
import "./sessions.css";
import Levels from "./components/Levels";
import PreviousSession from "./components/PreviousSession";
import Loader from "../../../components/Loader";
import { fetchSessions as fetchSessionsUtil } from "../../../utils/fetchSessions";

function ResultSessions() {
  const [load, setLoad] = useState(false);
  const [currentSession, setCurrentSession] = useState(null);
  const [otherSessions, setOtherSessions] = useState([]);
  const [error, setError] = useState(null);

  const fetchSessions = useCallback(async () => {
    setLoad(true);
    setError(null);
    try {
      const json = await fetchSessionsUtil();
      setCurrentSession(json.sessions.find((s) => s.current) || null);
      setOtherSessions(json.sessions.filter((s) => !s.current));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoad(false);
    }
  }, []);

  useEffect(() => {
    fetchSessions();
  }, [fetchSessions]);

  return (
    <div className="cr_page">
      <div className="cr_header">
        <div>
          <p className="cr_overline">Academic Tools</p>
          <h2>Results</h2>
          <p className="cr_subtitle">
            View and manage student results by session and level.
          </p>
        </div>
      </div>

      {load && <Loader />}

      {error && (
        <div className="cr_error">
          {error} —{" "}
          <button className="cr_retry" onClick={fetchSessions}>
            Retry
          </button>
        </div>
      )}

      {currentSession && (
        <div className="cr_section">
          <div className="cr_section_head">
            <span className="cr_section_label">Current Session</span>
            <span className="cr_session_badge">{currentSession.session}</span>
          </div>
          <Levels
            session={currentSession.session}
            classes={currentSession.classes || []}
          />
        </div>
      )}

      {otherSessions.length > 0 && (
        <div className="cr_section">
          <div className="cr_section_head">
            <span className="cr_section_label">Other Sessions</span>
          </div>
          <div className="cr_session_list">
            {otherSessions.map((s) => (
              <PreviousSession key={s.session} session={s.session} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ResultSessions;
